import React from 'react';
import g from 'glamorous';
import Helmet from 'react-helmet';

import Banner from '../../components/banner';
import ResponsiveMargin from '../../components/responsive-margin';
import Sitenav from '../../components/sitenav';
import heroUrl from './CharacterBio2PageHero40@2x.jpg';

export default () => (
  <div>
    <Helmet title="Berenice Abbott | The Realist | Sarah Coleman" />
    <Banner imageUrl={heroUrl}/>
    <Sitenav/>
    <ResponsiveMargin css={{maxWidth: '640px'}}>
      <h6>The Realist | Character Bios</h6>
      <h2>Berenice Abbott</h2>

      <p>Berenice Abbott’s sixty-year photography career began in the 1920s when she worked as a darkroom assistant for Man Ray. It was Man Ray who suggested Abbott take photos. She quickly realized her passion for photography and within a few years she opened her own portrait studio at 44 rue de Bac.</p>

      <p>Prior to arriving in Paris, Abbott had dropped out of Ohio State University and spent many years working an array of jobs, including waitressing, in New York City. While there, she tried to become a sculptor and continued this career in Paris. However, it wasn’t until she discovered photography that she was recognized for her artistic talent.</p>

      <p>Abbott had her first solo art exhibit, Portraits Photographiques, at the Jan Silvinsky Gallery in 1926, launching her name into the photo world. For the next few years, her life as a portrait photographer flourished. Abbott also discovered the work of Eugene Atget, whom she admired, which had a huge impact on her work. This period of Abbott’s career is known as the “Paris Portraits,” and you can view some of these stills <a target="_blank" href="http://www.commercegraphics.com/ba_portraits.html">here</a>.</p>

      <p>She returned to New York City In 1929 where she opened a studio in the Hotel des Artistes and started capturing the city in a series of pictures from “bird’s-eye and worm’s-eye points-of-view.” Abbott shot the city as it suffered through The Great Depression. A portion of this work was funded by the Federal Art Project and a decade later, the photos were published as a collection entitled <a target="_blank" href="https://digitalcollections.nypl.org/collections/changing-new-york"><em>Changing New York.</em></a></p>

      <p>In the 1930s, Abbott developed an interest in “the possibilities of photography as an interpreter of science.” She worked with the Physical Sciences Study Committee at the Massachusetts Institute of Technology, and the photos from that stretch were published in three books, <em>Magnet</em>, <em>Motion</em>, and <em>The Attractive Universe</em>.</p>

      <p>In 1971 the Museum of Modern Art had <a target="_blank" href="https://www.moma.org/calendar/exhibitions/2675">an exhibit to celebrate Berenice’s life’s work</a>.</p>
    </ResponsiveMargin>
  </div>
);



// WEBPACK FOOTER //
// ./src/pages/the-realist/berenice-abbott.js